import { ReportsModal } from '@/shared/components/reports-modal'
import { FiUser, FiFile } from 'react-icons/fi'
import { useLoaderData } from 'react-router-dom'

export const AssetV2Reports = () => {
  const { data: columns = [] } = useLoaderData()

  const reportOptions = [
    {
      label: 'Tabla de activos 2.0',
      description:
        'Descarga la información de la tabla de activos 2.0. Puedes seleccionar las columnas.',
      value: 'asset_v2',
      icon: FiUser,
      columns
    },
    {
      label: 'Listado de documentos',
      description: 'Descarga el listado de documentos asociados a los activos 2.0.',
      value: 'asset_v2_attachments',
      icon: FiFile,
      columns: []
    }
  ]

  return <ReportsModal reportOptions={reportOptions} />
}
